import React, { useRef, useState } from "react";
import { Mention } from 'primereact/mention';
import '../apps.css';
import { Button } from "primereact/button";
import FlexComponent from "../../FlexComponent";
import MentionOthers from "../../MentionOthers";
import { Avatar } from "primereact/avatar";
import { createComment, deleteComment, updateComment } from "../../../utils/urls";
import axios from '../../../utils/axios';
import { useSelector } from "react-redux";
import { Divider } from "primereact/divider";
import fbImage from "../../../Images/fbImage.png";
import instaImage from "../../../Images/instaImage.png";
import emailIcon from "../../../Images/email-icon.png";
import adminLogo from '../../../Images/admin_img.jpg';
import TranscriptChat from "./TranscriptChat";
import CallRecording from "./CallRecording";
import CallParticipant from "../CallParticipant";

export default function Activity({ handleClose, toast, formId, usersList, section = "popup", comments, contacts }) {

    const [value, setValue] = useState('');
    const [editValue, setEditValue] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [editUsers, setEditUsers] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [commentsData, setCommentsData] = useState(comments);
    const [isEdit, setIsEdit] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const user = useSelector((state) => state.user);
    const [commentLoad, setCommentLoad] = useState(false);
    const [hideCheckListItems, setHideCheckListItems] = useState(true);
    const [isVisble, setIsvisible] = useState(true);
    const [expandedTranscripts, setExpandedTranscripts] = useState(new Set());

    const toggleTranscript = (commentId) => {
        setExpandedTranscripts(prev => {
            const next = new Set(prev);
            if (next.has(commentId)) next.delete(commentId);
            else next.add(commentId);
            return next;
        });
    };

    // Auto-scroll is on by default; this tracks the calls it's been turned off for.
    const [autoScrollOff, setAutoScrollOff] = useState(new Set());

    const toggleAutoScroll = (commentId) => {
        setAutoScrollOff(prev => {
            const next = new Set(prev);
            if (next.has(commentId)) next.delete(commentId);
            else next.add(commentId);
            return next;
        });
    };
    const isSuperuser = useSelector((state) => state.user.isSuperuser);

    // Refs for textarea (using inputRef)
    const mentionRef = useRef(null);
    const editMentionRef = useRef(null);

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    const onSearch = (event) => {
        setTimeout(() => {
            const query = event.query.toLowerCase();
            let filteredSuggestions = [];

            if (!query.trim().length) {
                filteredSuggestions = [...usersList];
            } else {
                filteredSuggestions = usersList.filter((user) =>
                    user.label.toLowerCase().startsWith(query)
                );
            }

            setSuggestions(filteredSuggestions);
        }, 250);
    };

    // Auto-resize textarea based on content
    const autoResize = (ref) => {
        if (ref && ref.current) {
            const textarea = ref.current;
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight + 2}px`;
        }
    };

    // console.log("value----", value);

    const handleSaveNote = () => {
        const data = {
            comment: value,
            mention: selectedUsers.map(item => ({ id: item.id })),
            type: "comment"
        };
        setCommentLoad(true);
        const Url = `${createComment}${formId}/${user.userId}`;
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    const newCommentObj = {
                        user_name: user.userName,
                        user_id: user.userId,
                        user_image: user.image,
                        comment_id: response.data.comment_id,
                        type: "comment",
                        comment: value,
                        mention: selectedUsers,
                        created_at: response.data.created_at
                    };
                    setCommentsData(prev => [newCommentObj, ...prev]);
                    setCommentLoad(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleClose();
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleClose();
            });

        setValue('');
        setSelectedUsers([]);
        setTimeout(() => autoResize(mentionRef), 0); // Reset height
    };

    const handleDelete = (commentId) => {
        const updatedData = commentsData?.filter(comment => comment.comment_id !== commentId);
        setCommentsData(updatedData);
        const Url = `${deleteComment}${commentId}`;
        axios.post(Url, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status !== 200) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleClose();
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleClose();
            });
    };

    const handleEdit = (index) => {
        setIsEdit(true);
        setEditIndex(index);
        setEditValue(commentsData[index].comment);
        setEditUsers(extractUsers(commentsData[index].comment));
        setTimeout(() => autoResize(editMentionRef), 0); // Resize after render
    };

    const handleCancel = () => {
        setIsEdit(false);
        setEditIndex(null);
        setEditValue('');
        setEditUsers([]);
        setTimeout(() => autoResize(editMentionRef), 0);
    };

    const handleSaveEdit = (commentId) => {
        const data = {
            comment: editValue,
            mention: editUsers.map(item => ({ id: item.id })),
        };
        const updatedData = [...commentsData];
        updatedData[editIndex].comment = editValue;
        updatedData[editIndex].mention = editUsers;
        setCommentsData(updatedData);
        setIsEdit(false);
        setEditIndex(null);
        setEditValue('');
        setEditUsers([]);

        const Url = `${updateComment}${commentId}`;
        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status !== 200) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleClose();
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleClose();
            });
    };

    const extractUsers = (text) => {
        const mentionPattern = /@([\w.-]+)/g;
        const mentions = [...text.matchAll(mentionPattern)].map(match => match[1]);
        return mentions.map(mention => {
            const user = usersList.find(user => user.label.replace(/\s+/g, '').toLowerCase() === mention.toLowerCase());
            return user ? { id: user.value, name: user.label, image: user.image } : null;
        }).filter(user => user !== null);
    };

    const stripHtml = (html) => {
        if (!html) return '';
        return html.replace(/<[^>]*>/g, '').trim();
    };

    const highlightMentionsAndUrls = (text) => {
        const mentionRegex = /@[\w.-]+/g;
        const urlRegex = /(https?:\/\/[^\s)]+)/g;

        const parts = text.split(/(@[\w.-]+|https?:\/\/[^\s)]+|\n)/g);

        return parts.map((part, index) => {
            if (/^@[\w.-]+$/.test(part)) {
                return (
                    <span
                        key={`mention-${index}`}
                        style={{ color: '#2FC623' }}
                        className="mention"
                    >
                        {part}
                    </span>
                );
            } else if (/^https?:\/\/[^\s)]+$/.test(part)) {
                return (
                    <a
                        key={`url-${index}`}
                        href={part}
                        style={{ color: '#00FF2F' }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {part}
                    </a>
                );
            } else if (part === '\n') {
                return <br key={`br-${index}`} />;
            } else {
                return part;
            }
        });
    };

    const onChange = (e) => {
        const inputValue = e.target.value;
        setValue(inputValue);
        setSelectedUsers(extractUsers(inputValue));
        autoResize(mentionRef);
    };

    const onEditChange = (e) => {
        const inputValue = e.target.value;
        setEditValue(inputValue);
        setEditUsers(extractUsers(inputValue));
        autoResize(editMentionRef);
    };

    const itemTemplate = (suggestion) => {
        return (
            <div className="flex align-items-center">
                <span className="flex flex-column ml-2">
                    {suggestion.label}
                </span>
            </div>
        );
    };

    return (
        <div className="activity" style={{ overflow: "hidden" }}>
            <FlexComponent style={{ paddingBottom: (section === "popup" && !isVisble) && "100px" }}>
                {section === "popup" && <div><i className="pi pi-history"></i><span style={{ marginLeft: "7px" }}>Activity</span></div>}
                <FlexComponent justifyContent="start" width="auto" gap="1rem">
                    {(isVisble || section !== "popup") && (
                        <Button
                            style={{ boxShadow: "none", padding: "0.4rem 1rem", border: "1px solid grey", marginLeft: ".5rem" }}
                            onClick={() => setHideCheckListItems(!hideCheckListItems)}
                        >
                            {hideCheckListItems ? `Show Check List Items` : 'Hide Check List Items'}
                        </Button>
                    )}
                    {section === "popup" && (
                        <div style={{ cursor: "pointer" }} onClick={() => setIsvisible(!isVisble)}>
                            <i className={isVisble ? 'pi pi-minus' : 'pi pi-plus'} style={{ marginRight: "25px" }}></i>
                        </div>
                    )}
                </FlexComponent>
            </FlexComponent>

            {(section !== "popup" || isVisble) && (
                <div>
                    <FlexComponent
                        justifyContent="start"
                        alignItems="start"
                        gap="1rem"
                        style={{
                            width: section === "popup" ? "100%" : "93%",
                            marginTop: '0.7rem',
                            marginLeft: section !== "popup" && "1rem"
                        }}
                        className="commentSectionContainer"
                    >
                        <Avatar
                            style={{ width: '40px', height: '40px', color: 'black' }}
                            image={user.userName === "admin" ? adminLogo : user?.image}
                            shape='circle'
                            label={getInitials(user.userName)}
                        />
                        <Mention
                            inputRef={mentionRef}
                            value={value}
                            onChange={onChange}
                            suggestions={suggestions}
                            onSearch={onSearch}
                            field="label"
                            placeholder="Write a comment..."
                            rows={1}
                            itemTemplate={itemTemplate}
                            className={section === "popup" ? "mention-input" : "profile-input"}
                        />
                    </FlexComponent>

                    <div style={{ marginLeft: section === "popup" ? "8%" : "10%", marginTop: "10px" }}>
                        {value?.trim() && <Button onClick={handleSaveNote}>Save</Button>}
                    </div>

                    <FlexComponent
                        className='appSection applicantContainer'
                        justifyContent="start"
                        flexDirection="column"
                        gap={section === "popup" ? "1rem" : ""}
                        style={{ margin: '1rem 0' }}
                    >
                        {commentLoad && (
                            <div style={{ width: "100%" }}>
                                <FlexComponent alignItems="start">
                                    <div>
                                        <Avatar style={{ width: '35px', height: '35px', color: 'black' }} shape='circle' />
                                    </div>
                                    <div
                                        style={{
                                            width: section === "popup" ? "93%" : "100%",
                                            height: "50px",
                                            borderRadius: "10px",
                                            background: section === "profileView" && "grey"
                                        }}
                                        className="loadingAppItem"
                                    />
                                </FlexComponent>
                            </div>
                        )}

                        {commentsData?.map((comment, index) => (
                            <div
                                key={index}
                                style={{
                                    width: "100%",
                                    display: hideCheckListItems && comment.type === "checklist" ? "none" : ""
                                }}
                            >
                                <FlexComponent
                                    gap={section === "popup" ? "" : "1rem"}
                                    alignItems="start"
                                    className="commentSectionContainer"
                                    style={{ height: index + 1 === commentsData.length && section === "popup" && '35vh' }}
                                >
                                    <div>
                                        {comment.type === "Facebook" ? (
                                            <Avatar image={fbImage} style={{ width: '35px', height: '35px', color: 'black', background: "white" }} shape='circle' />
                                        ) : comment.type === "Instagram" ? (
                                            <Avatar image={instaImage} style={{ width: '35px', height: '35px', color: 'black', background: "white" }} shape='circle' />
                                        ) : comment.type === "follow_up" ? (
                                            <Avatar image={emailIcon} style={{ width: '35px', height: '35px', color: 'black', background: "white" }} shape='circle' />
                                        ) : (
                                            <Avatar
                                                image={comment.user_name === "admin" ? adminLogo : comment.user_image}
                                                style={{ width: '35px', height: '35px', color: 'black' }}
                                                shape='circle'
                                                label={getInitials(comment?.user_name)}
                                            />
                                        )}
                                    </div>

                                    <div style={{ width: section === "popup" ? "93%" : "100%" }} className="commentSectionDiv">
                                        <FlexComponent justifyContent="start" gap="0.5rem" style={{ marginTop: section === "popup" ? "" : ".4rem" }}>
                                            {comment.type !== "Facebook" && comment.type !== "Instagram" && comment.type !== "follow_up" && (
                                                <p style={{ fontSize: '14px', color: section === "popup" ? 'white' : "white", fontWeight: "bold" }}>
                                                    {comment?.user_name}
                                                </p>
                                            )}
                                            <p style={{ fontSize: '12px', color: '#B1B1B1' }}>{comment?.created_at}</p>
                                        </FlexComponent>

                                        {!isEdit || editIndex !== index ? (
                                            <>
                                                {comment.type !== "call" && (
                                                    <FlexComponent
                                                        gap="1rem"
                                                        style={{
                                                            margin: "0.5rem 0",
                                                            border: (comment.type === "comment" && section === "popup") ? '2px solid grey' : comment.type === "comment" && '1px solid #dee2e6',
                                                            padding: comment.type === "comment" || section === "popup" ? "0.5rem" : "0.5rem 0",
                                                            background: section === "popup" ? '#0808086b' : "transparent",
                                                            borderRadius: ".5rem",
                                                        }}
                                                    >
                                                        <p style={{ wordBreak: "break-word" }}>
                                                            {highlightMentionsAndUrls(stripHtml(comment.comment))}
                                                            <MentionOthers mentions={comment.mention} />
                                                        </p>
                                                    </FlexComponent>
                                                )}
                                            </>
                                        ) : (
                                            <Mention
                                                inputRef={editMentionRef}
                                                value={editValue}
                                                onChange={onEditChange}
                                                suggestions={suggestions}
                                                onSearch={onSearch}
                                                field="label"
                                                placeholder="Edit comment..."
                                                rows={1}
                                                itemTemplate={itemTemplate}
                                                className="edit-mention-input"
                                                style={{ width: "100%", margin: "0.5rem 0" }}
                                            />
                                        )}

                                        {(comment.user_id === user.userId || isSuperuser) && comment.type === "comment" && (
                                            <FlexComponent justifyContent="start" gap="0.3rem">
                                                {!isEdit || editIndex !== index ? (
                                                    <>
                                                        <a style={{ color: '#B1B1B1', fontSize: "14px", cursor: "pointer" }} onClick={() => handleDelete(comment.comment_id)}>
                                                            delete
                                                        </a>
                                                        <a style={{ color: '#B1B1B1', fontSize: "14px", cursor: "pointer" }} onClick={() => handleEdit(index)}>
                                                            edit
                                                        </a>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button
                                                            style={{ color: 'white', fontSize: "14px", cursor: "pointer", background: "#2FC635" }}
                                                            onClick={() => handleSaveEdit(comment.comment_id)}
                                                            disabled={!editValue?.trim()}
                                                        >
                                                            save
                                                        </Button>
                                                        <Button
                                                            style={{ color: 'black', fontSize: "14px", cursor: "pointer", background: "white" }}
                                                            onClick={handleCancel}
                                                        >
                                                            Discard Changes
                                                        </Button>
                                                    </>
                                                )}
                                            </FlexComponent>
                                        )}

                                        {comment.type === "call" && (
                                            <FlexComponent
                                                justifyContent="start"
                                                flexDirection="column"
                                                alignItems="start"
                                                gap="0.5rem"
                                                style={{
                                                    marginTop: ".5rem",
                                                    background: section === "popup" ? '#0808086b' : "transparent",
                                                    borderRadius: ".5rem",
                                                    padding: section === "popup" ? "1rem" : ""
                                                }}
                                            >
                                                <CallParticipant contacts={contacts} contactId={comment.contact_id} />
                                                <CallRecording src={comment?.comment}>
                                                {comment.transcription && (
                                                    <>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                                            <button
                                                                onClick={() => toggleTranscript(comment.comment_id)}
                                                                style={{
                                                                    display: 'flex', alignItems: 'center', gap: '5px',
                                                                    background: 'rgba(255,255,255,0.07)',
                                                                    border: '1px solid rgba(255,255,255,0.15)',
                                                                    borderRadius: '6px',
                                                                    color: '#B1B1B1',
                                                                    fontSize: '12px',
                                                                    padding: '4px 10px',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <i className={`pi pi-chevron-${expandedTranscripts.has(comment.comment_id) ? 'up' : 'down'}`} style={{ fontSize: 10 }} />
                                                                {expandedTranscripts.has(comment.comment_id) ? 'Hide' : 'Show'} Transcript
                                                            </button>
                                                            {expandedTranscripts.has(comment.comment_id) && (
                                                                <button
                                                                    onClick={() => toggleAutoScroll(comment.comment_id)}
                                                                    aria-pressed={!autoScrollOff.has(comment.comment_id)}
                                                                    title="Keep the transcript scrolled to the part being played"
                                                                    style={{
                                                                        display: 'flex', alignItems: 'center', gap: '5px',
                                                                        background: autoScrollOff.has(comment.comment_id) ? 'rgba(255,255,255,0.07)' : 'rgba(77,155,245,0.15)',
                                                                        border: `1px solid ${autoScrollOff.has(comment.comment_id) ? 'rgba(255,255,255,0.15)' : 'rgba(77,155,245,0.6)'}`,
                                                                        borderRadius: '6px',
                                                                        color: autoScrollOff.has(comment.comment_id) ? '#B1B1B1' : '#4d9bf5',
                                                                        fontSize: '12px',
                                                                        padding: '4px 10px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    <i className="pi pi-arrows-v" style={{ fontSize: 10 }} />
                                                                    Auto Scroll {autoScrollOff.has(comment.comment_id) ? 'Off' : 'On'}
                                                                </button>
                                                            )}
                                                        </div>
                                                        {expandedTranscripts.has(comment.comment_id) && (
                                                            <TranscriptChat
                                                                transcription={comment.transcription}
                                                                userName={comment.user_name}
                                                                autoScroll={!autoScrollOff.has(comment.comment_id)}
                                                            />
                                                        )}
                                                    </>
                                                )}
                                                </CallRecording>
                                            </FlexComponent>
                                        )}
                                    </div>
                                </FlexComponent>
                                {section === "profileView" && <Divider />}
                            </div>
                        ))}
                    </FlexComponent>
                </div>
            )}
        </div>
    );
}